import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
// Trigger prerender
if (typeof window !== "undefined") {
  document.dispatchEvent(new Event("prerender-trigger"));
}